import React, { useState, useEffect, useContext } from "react";
import Alert from '@mui/material/Alert';

import { DeviceContext, deviceType } from '@providers';

const CartErrorsAlert = ({ errorMessages }) => {
  const { isMobile } = useContext<deviceType>(DeviceContext);

  const [showAlerts, setShowAlerts] = useState(errorMessages.map(() => true));

  useEffect(() => {
    setShowAlerts(errorMessages.map(() => true));
  }, [errorMessages]);

  const handleClose = (index) => {
    setShowAlerts((prev) => {
      const newShowAlerts = [...prev];
      newShowAlerts[index] = false;

      return newShowAlerts;
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", padding: `${isMobile ? "16px" : "0"}` }}>
      {
        errorMessages?.map((errorMessage, i) => (
          showAlerts[i] && (
            <Alert
              key={i}
              severity="warning"
              onClose={() => handleClose(i)}
            >
              {errorMessage.message}
            </Alert>
          )
        ))
      }
    </div>
  );
};

export default CartErrorsAlert;
